var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7194 6.87487C14.951 6.64298 15.0811 6.32863 15.0811 6.00089C15.0811 5.67315 14.951 5.3588 14.7194 5.12691L10.0559 0.46099C9.8239 0.228977 9.50922 0.0986326 9.18111 0.0986326C8.85299 0.0986325 8.53831 0.228976 8.3063 0.46099C8.07429 0.693003 7.94394 1.00768 7.94394 1.3358C7.94394 1.66391 8.07428 1.97859 8.3063 2.21061L10.859 4.76412L1.34824 4.76412C1.02023 4.76412 0.70565 4.89442 0.473711 5.12636C0.241771 5.3583 0.111469 5.67288 0.111469 6.00089C0.111469 6.3289 0.241771 6.64348 0.473711 6.87542C0.70565 7.10736 1.02023 7.23766 1.34824 7.23766L10.859 7.23766L8.3063 9.79035C8.19142 9.90523 8.10029 10.0416 8.03812 10.1917C7.97594 10.3418 7.94394 10.5027 7.94394 10.6652C7.94394 10.8276 7.97594 10.9885 8.03812 11.1386C8.10029 11.2887 8.19142 11.4251 8.3063 11.54C8.42118 11.6548 8.55756 11.746 8.70766 11.8081C8.85776 11.8703 9.01864 11.9023 9.18111 11.9023C9.34357 11.9023 9.50445 11.8703 9.65455 11.8081C9.80465 11.746 9.94103 11.6548 10.0559 11.54L14.7194 6.87487Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.b4a6fcb3a138ee8e308601f59c919b71.svg";
export { ForwardRef as ReactComponent };